import React, { useEffect, useState } from "react";
import { Table,Modal } from "antd";
import FETCH from "../../../utils/fetch";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import { MODULE_API } from "../../../apis";
import DEATH_API from "../../../apis/death.api";
import matchImg from ".../../assets/images/DeathModuleNew/Checkbox.png";
import cancelImg from ".../../assets/images/DeathModuleNew/delete.png";
import axios from "axios";
import swal from "sweetalert";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
export const AssetAssignLiquid = ({
  rows,
  data,
  handleLiquidModuleToUpdate,
  cbFormChange,
  allLiabilities,
  attributeValues
}) => {
  const [loading, setLoading] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const [assetsList, setAssetsList] = useState([]);
  const [goalsWithAssets, setGoalsWithAssets] = useState([]);
  const [liabilities, setLiabilities] = useState(allLiabilities);
  const [loanForAssets,setLoanForAssets]=useState(null);
  const [total, setTotal] = useState(null);
  const [dataSource, setDataSource] = useState(rows);
  const [count, setCount] = useState(rows && rows.length + 1);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);

  const [assetsWithGoal, setAssetsWithGoal] = useState([]);
  const [dataRes, setDataRes] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [snowball, setSnowball] = useState(null);

  const totalAmountToUse = dataSource &&  dataSource.reduce((sum, item) => {
    return sum + (item["amountUseForGoal"] || 0);
  }, 0);

  const [totalAmount, setTotalAmount] = useState(0);
  const [assetsToUpdate, setAssetsToUpdate] = useState([]);
  const [totalAmountUsed,setTotalAmountUsed]=useState(totalAmountToUse);

  useEffect(()=>{
    setDataSource(rows);
    const amountUsed =rows && Array.isArray(rows)
      ? rows.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0)
      : 0;
    const havefromFriends=data && data["Amount Received"] && (data["Amount Received"] && Array.isArray(data["Amount Received"]) ? data["Amount Received"].reduce((acc, curr) => acc + curr, 0) : 0);
    const totalhave=amountUsed+havefromFriends;
      setTotalAmount(totalhave);
  },[rows])
  
  const handleAdd = async (record) => {
    if (dataSource && dataSource.some((item) => item.assetId === record.id)) {
      swal("Info", "This asset has already been added.", "info");
      return;
    }
    setAssetsToUpdate((prevAddedIds) => [...prevAddedIds, record.id]);
    let result =
      record && calculateGoalRequirements(record, data, transformedData);
    const havefromFriends=data && data["Amount Received"] && (data["Amount Received"] && Array.isArray(data["Amount Received"]) ? data["Amount Received"].reduce((acc, curr) => acc + curr, 0) : 0);
    const amountUsed = rows && Array.isArray(rows)
      ? rows.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0) + parseFloat(havefromFriends || 0)
        : parseFloat(havefromFriends || 0);
    const goalNeedToday = parseFloat(
      result.goalNeedToday.replace(/[^0-9.-]+/g, "")
    );
    let totalNeed = totalAmount + parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g, ""));
    setTotalAmount(totalNeed);
    // setTotalAmount(
    //   (prevState) => prevState + (parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g,"")) || 0)
    // );
    console.log("totalNeed", goalNeedToday, amountUsed, totalNeed);
    if (goalNeedToday > totalNeed && amountUsed < goalNeedToday) {
      let totalFunded = goalNeedToday - totalNeed;
      let totalFundedPercentage = ((totalNeed / goalNeedToday) * 100).toFixed(
        2
      );
      console.log("totalFunded", totalNeed, totalFunded, totalFundedPercentage);
      swal("", `This Goal is ${totalFundedPercentage}% funded.`, "warning");
    } else {
      if (amountUsed > goalNeedToday) {
        swal("Oops", "Goal Need Already Fulfilled", "error");
        console.log("totalNeed in return case");
        return;
      } else {
        // let moduleToCreate = {
        //   "Name of Asset":
        //     record && record["Name of Asset"]
        //       ? "Remaining from Sale of " + record["Name of Asset"]
        //       : null,
        //   "Monetary Value": totalNeed - goalNeedToday, //record && record["Monetary Value"] ? +record["Monetary Value"] :0,
        //   "Cost Basis Date": record["Cost Basis Date"]
        //     ? record["Cost Basis Date"]
        //     : new Date(),
        //   "Cost Basis": record["Cost Basis"] ? +record["Cost Basis"] : 0,
        //   "Value as of Date": record["Value as of Date"]
        //     ? record["Value as of Date"]
        //     : new Date(),
        //   "Date of Sale":
        //     data && data["Goal Date"]
        //       ? new Date(data["Goal Date"])
        //       : new Date(),
        // };
        let moduleIdsToSend=[...assetsToUpdate,record.id];
        console.log("moduleIdsToSend",moduleIdsToSend)
        handleLiquidModuleToUpdate(moduleIdsToSend,record.goal_id ? record.goal_id :[]);
        // handleCashModuleCreate(moduleToCreate);
        // setLoading(true);
        // const moduleNew=await MODULE_API.addAsset(moduleName, {
        //   clientModules: [
        //     moduleToCreate,
        //   ],
        // });
        // setLoading(false);
        swal("Success", "Goal Fully Funded!", "success");
      }
    }
    console.log("record to create", record, result);
    if (amountUsed < goalNeedToday) {
      const Monetary =
        record && record["Monetary Value"] ? +record["Monetary Value"] : 0;
      const taxOnRecord = record && record["Taxes"] ? record["Taxes"] : 0;
      const amountAvailable=record && record.amountAvailable ?  record.amountAvailable : 0
      const netPaid = Monetary - taxOnRecord;
      const amountToUse= result && result.equityForGoal
      ? parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g, "")) >
        goalNeedToday
        ? goalNeedToday - amountUsed
        : parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g, ""))
      : 0;
      const amountToUseinGoal = dataSource && dataSource.reduce((sum, item) => {
        return sum + (item["amountUseForGoal"] || 0);
      }, 0);
      const totalAmountToUse=amountToUse +amountToUseinGoal;
      setTotalAmountUsed(totalAmountToUse);
      console.log("amountToUse",amountToUse,dataSource)
      const newData = {
        key: count.toString(),
        assetId: record.id,
        priority: count,
        asset:
          record && record["Name of Asset"] ? record["Name of Asset"] : null,
        "valueOfAssetGoalRate":
          record && record["Monetary Value"] ? +record["Monetary Value"] : null,
        // "Value of Asset at goal date":
        //   record && record.amountAvailable ? record.amountAvailable : null,
        "loanValueGoalDate":
          result && result.loanPayableForAsset
            ? parseFloat(result.loanPayableForAsset.replace(/[^0-9.-]+/g, ""))
            : null,
        "amountUseForGoal":
          result && result.equityForGoal
            ? parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g, "")) >
              goalNeedToday
              ? goalNeedToday - amountUsed
              : parseFloat(result.equityForGoal.replace(/[^0-9.-]+/g, ""))
            : 0,
        "Amount used in other goal":  record && record.sumOfAmountUsed ? record.sumOfAmountUsed : null,
        taxes: record && record["Taxes"] ? record["Taxes"] : null,
        "netAmountAfterTax": totalAmountToUse && totalAmountToUse ? totalAmountToUse : null,
      };
      console.log("newData", newData);
      let dataToSave = [newData, ...dataSource];
      setDataSource([...dataSource, newData]);
      console.log("newData222", dataSource, dataToSave);
      setCount(count + 1);
      cbFormChange([...dataSource, newData]);
    }
  };
  const handleDelete = (record) => {
    // const newData = dataSource && dataSource.filter(item => item.asset_id !== record.id);
    // "Amount to use for this goal"
    let amountToUse=0;
    let totalAmountToUse=totalAmountUsed;
    const updatedAssetsToUpdate = assetsToUpdate && assetsToUpdate.filter(item => item !== record.id);
    const matchedData = dataSource && dataSource.find(item => item.assetId === record.id);
    if (matchedData) {
        amountToUse = parseFloat(matchedData.amountUseForGoal) || 0;
        totalAmountToUse=totalAmountToUse-amountToUse;
        // Subtract the amount from totalAmount
        setTotalAmount(prevState => prevState - amountToUse);
        setTotalAmountUsed(prevState => prevState - amountToUse);

    }
    console.log("totalAmountToUse",totalAmountToUse)
    const newData = dataSource && dataSource.map(item => {
      // Adjust the "Amount to use for this goal" for all records
      return {
        ...item,
        "Net after tax applied to goals": (parseFloat(totalAmountToUse) || 0)
      };
    }).filter(item => item.assetId !== record.id);
    setAssetsToUpdate(updatedAssetsToUpdate);
    setCount(count - 1);
    setDataSource(newData);
    cbFormChange(newData);
  };
  const getLiabilityList = async (page) => {
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: `?module=Liabilities and Credit&page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);

      if (datares && datares.records) {
        // Cache the data for the current page
        setLiabilities(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAssetsList = async (page) => {
    console.log("here in cached data", cachedData, page);
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const id = JSON.parse(localStorage.getItem('accessId'))
        let datares = await FETCH.post({
          url: "client-module-service/client-module/liquid",
          id: userRole === "Financial Advisor Client" ? `?page=${page}&limit=10&clientId=${id}` : `?page=${page}&limit=10`,
          body: {},
        });
      setLoading(false);
      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAssetLoan = async (id) => {
    try {
      setLoading(true);
      let payload = {
        cmId: id,
      };
      // const response = await DEATH_API.fetchAssetLoan(payload);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = "http://192.168.1.11:3000";
      const response = await axios.post(
        `${baseUrl}/fetch/assets/with/loan`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response", response.data);
      if (response && response.data && response.data.status === 200) {
        let liablityData = response.data.data;
        // setLiabilities([liablityData]);
        swal("Success", response.data.message, "success");
      }
      if (response && response.data && response.data.status === 400) {
        swal("Error", response.data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response.data) {
        swal("Error", error.response.data.message, "error");
      }
      console.error("Error fetching user data:", error);
    }
  };
  // function getMonthsDifference(date1, date2) {
  //   const year1 = date1.getFullYear();
  //   const year2 = date2.getFullYear();
  //   const month1 = date1.getMonth();
  //   const month2 = date2.getMonth();

  //   return (year2 - year1) * 12 + (month2 - month1);
  // }
    function getMonthsDifference(date1, date2) {
    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let totalMonths = years * 12 + months;

    // Adjust if end day is less than start day (Excel style)
    if (date2.getDate() < date1.getDate()) {
      totalMonths--;
    }

    return totalMonths;
  }
  const calculateGoalNeed = (record, data) => {
    const GoalNeedToday = data["Dollar Amount Needed"]
      ? data["Dollar Amount Needed"]
      : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const GoalInflationRate = 10;
    const GoalDate = data["Goal Date"]
      ? new Date(data["Goal Date"])
      : new Date();
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    // Calculate the number of days between GoalDate and todaysDate
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // Calculate the formula
    // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    console.log("result", result);
    return result;
  };
  const calculateGoalRequirements = (record, data, amortization) => {
    const assetName = record["Name of Asset"];
    const amortizationofRecord = amortization && amortization[assetName];
    const todaysDate = new Date();
    const GoalDate = data["Goal Date"]
      ? new Date(data["Goal Date"])
      : new Date();

    // loan paybale till goal date against asset
    // const loanPaybaleForAsset = amortizationofRecord
    //   ? amortizationofRecord
    //       .filter((record) => new Date(record.date) <= GoalDate)
    //       .reduce((total, record) => {
    //         const payable = record.valuepayable;
    //         return total + (typeof payable === "number" ? payable : 0);
    //       }, 0)
    //   : 0;

    // loan paybale after goal date against asset
    const loanPaybaleForAsset = amortizationofRecord
      ? amortizationofRecord
          .filter((record) => new Date(record.date) >= GoalDate)
          .reduce((total, record) => {
            const payable = record.valuepayable;
            return total + (typeof payable === "number" ? payable : 0);
          }, 0)
      : 0;
    console.log("loanPaybaleForAsset", loanPaybaleForAsset, amortization);
    const assetValueToday = record["Monetary Value"]
      ? +record["Monetary Value"]
      : 0;
    const taxabilityonAsset = record["Taxes"] ? +record["Taxes"] : 0;
    const rateofReturn = record["Static"] ? +record["Static"] : 0;
    const startDate = record["Cost Basis Date"]
      ? +record["Cost Basis Date"]
      : new Date();
    const costToSell = record["Commission on Sale"]
      ? +record["Commission on Sale"]
      : 0;
    const liabilityPayOff = record["Total Liabilities"]
      ? record["Total Liabilities"]
      : 0;
    const transactionCost = record["Other Transaction Costs"]
      ? record["Other Transaction Costs"]
      : 0;
    const equityForGoal = (
      assetValueToday -
      taxabilityonAsset -
      costToSell -
      // liabilityPayOff -
      transactionCost -
      loanPaybaleForAsset
    ).toFixed(2);
    const amountAvailable=equityForGoal-record.sumOfAmountUsed ? record.sumOfAmountUsed :0;
    const GoalNeedToday = data["Dollar Amount Needed"]
      ? data["Dollar Amount Needed"]
      : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const GoalInflationRate = 10;
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
      // calculate monthly saving for goal to fulfill need
      let amountAvailableForAsset=record.amountAvailable ? record.amountAvailable :result;
      let monthlySavings=0;
      const amountUsed = Array.isArray(data["Amount to use for this goal"])
      ? data["Amount to use for this goal"].reduce((acc, curr) => acc + curr, 0)
      : 0;
      if(result>amountAvailableForAsset){
        monthlySavings=(result-amountAvailableForAsset)/ (NumberofMonths=== 0 ? 1 : NumberofMonths);
      }
    const formattedEquityForGoal = parseFloat(equityForGoal)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const formattedResult = result
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const needAfterAsset =
      result === 0 ? result.toFixed(2) : (equityForGoal - result).toFixed(2);
    const formattedLoanPayable = loanPaybaleForAsset
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const monthlySavingRequired =
      NumberofMonths > 0 ? +needAfterAsset / NumberofMonths : 0;
    console.log(
      "equityForGoal",equityForGoal
    );
    return {
      equityForGoal: `$${formattedEquityForGoal}`,
      goalNeedToday: `$${formattedResult}`,
      needAfterAsset: `$${needAfterAsset
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
      loanPayableForAsset: `$${formattedLoanPayable}`,
      monthlySavingRequired: monthlySavings,
      newAssetCreated: needAfterAsset,
      amountAvailable:amountAvailable
    };
  };
  const getSelectedRecords = async (goalId,goals) => {
    setDetailsModal(true);
    const idsToMatch = goalId;
    const matchingRecords = goalsWithAssets && goalsWithAssets.filter(record => idsToMatch.includes(record.id));
    console.log("goals",goals,matchingRecords)
    const updatedMatchingRecords = matchingRecords && matchingRecords.map(matchingRecord => {
      const goal = goals && goals.find(goal => goal.goalId === matchingRecord.id);
      // If a matching goal is found, add amountUseForGoal to matchingRecord
      if (goal) {
        return {
          ...matchingRecord,
          amountUseForGoal: goal.amountUseForGoal || 0 // Add the amountUseForGoal if it exists
        };
      }
      return matchingRecord;
    });
    console.log("updatedMatchingRecords",updatedMatchingRecords)
    setSelectedObject(updatedMatchingRecords)

  };
  const handleCancel = () => {
    setDetailsModal(false);
    setSelectedObject(null);
  };

  // useEffect(() => {
  //   if(attributeValues && assetsList && assetsList.length>0){
  //     if(data["Goal Date"] !==attributeValues["Goal Date"]){
  //       console.log("rowwwwwAll liquid",dataSource,assetsList)
  //       dataSource && dataSource.forEach((row) => {
  //         const asset = assetsList.find((asset) => asset.id === row.asset_id);
  //         if (asset) {
  //           let result=calculateGoalRequirements(asset,data, transformedData);
  //           console.log("Asset with resultAll",result)
  //         } else {
  //           console.warn(`Asset with id ${row.asset_id} not found.`);
  //         }
  //       });
  //     }
  //   }
  //   }, [attributeValues,assetsList]);

  useEffect(() => {
    getAllDetails(currentPage);
  }, [currentPage]);
  const getAllDetails = async (currentPage) => {
    // await getLiabilityList(currentPage);
    await getAssetsList(currentPage);
  };

  function calculatePayments(liabilities) {
    if (!liabilities) {
      console.error("Missing required data.");
      return {};
    }

    const result = {};
    const maxIterations = 2000; // Set a maximum iteration limit

    liabilities.forEach((item) => {
      const nickname = item["Nickname of Liabilities"];
      let monthlyPayment = item["Monthly Payment"] || 0;
      let initialLoanAmount = item["Initial Loan Amount"] || 0;
      let startDate = item["Start Date"]
        ? new Date(item["Start Date"])
        : new Date();
      let endDate = item["Maturity Date"]
        ? new Date(item["Maturity Date"])
        : new Date();
      let interestRate = item["Interest Rate"] || 0;

      // Check if startDate and endDate are valid
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        console.error(`Invalid dates for liability: ${nickname}`);
        return;
      }

      if (typeof monthlyPayment === "string") {
        monthlyPayment = parseFloat(monthlyPayment.replace(/[$,]/g, "").trim());
      }

      if (typeof initialLoanAmount === "string") {
        initialLoanAmount = parseFloat(
          initialLoanAmount.replace(/[$,]/g, "").trim()
        );
      }

      if (typeof interestRate === "string") {
        interestRate =
          parseFloat(interestRate.replace(/[%]/g, "").trim()) / 100;
      }

      if (
        isNaN(monthlyPayment) ||
        isNaN(initialLoanAmount) ||
        isNaN(interestRate)
      ) {
        console.error(`Invalid data for liability: ${nickname}`);
        return;
      }

      const payments = [];
      let currentDate = new Date(startDate);
      const monthlyInterestRate = interestRate / 12;
      let remainingBalance = initialLoanAmount;
      let iterationCount = 0; // Initialize iteration counter

      // Calculate total number of months until the end date
      const numberOfMonths = Math.max(
        Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24 * 30)),
        0
      );
      // console.log("numberOfMonths",numberOfMonths)
      // Calculate total payable amount based on monthly payments
      const totalPayable = monthlyPayment * numberOfMonths;
      // console.log(`Total Payable for ${nickname}: ${totalPayable}`);

      while (currentDate <= endDate && iterationCount < maxIterations) {
        const interestPaid = remainingBalance * monthlyInterestRate;
        const principalPaid = Math.min(
          monthlyPayment - interestPaid,
          remainingBalance
        ); // Cap principal payment to remaining balance
        const valuePayable =
          Math.round((interestPaid + principalPaid) * 100) / 100;
        // console.log(`Date Till pay for ${nickname}: ${iterationCount}, ${principalPaid} ${interestPaid}`);

        // Only add payment if the value payable is greater than zero
        if (valuePayable > 0) {
          payments.push({
            date: moment(currentDate).format("MM-DD-YYYY"), // Format as MM-DD-YYYY
            valuepayable: valuePayable,
          });
        }

        remainingBalance -= principalPaid;

        // Ensure remaining balance is not negative
        if (remainingBalance <= 0) {
          remainingBalance = 0;
        }

        // Increment month
        currentDate.setMonth(currentDate.getMonth() + 1);

        // Check if the date is valid after increment
        if (isNaN(currentDate.getTime())) {
          console.error(
            `Invalid date after increment for liability: ${nickname}`
          );
          break;
        }

        iterationCount++; // Increment iteration counter
      }

      // If there are payments, ensure the total payments do not exceed the total payable
      if (payments.length > 0) {
        const totalPaymentsMade = payments.reduce(
          (total, payment) => total + payment.valuepayable,
          0
        );
        // console.log(`Total Payments Made for ${nickname}: ${totalPaymentsMade}`);

        if (totalPaymentsMade > totalPayable) {
          console.warn(
            `Total payments made exceed total payable for liability: ${nickname}`
          );
        }
      }

      result[nickname] = payments;
    });
    // setLoanForAssets(result);
    return result;
  }

  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      const filteredAssets = datares.records.filter(
        (record) =>
          !record.hasOwnProperty("This Asset is Liquid") ||
          record["This Asset is Liquid"] === true
      );
      if(datares.goals){
        const allGoals=datares.goals && datares.goals;
        setGoalsWithAssets(allGoals);
        const assetsWithGoal=updateAssetsWithGoalInfo(filteredAssets,allGoals,loanForAssets);
        console.log("assetsWithGoal",assetsWithGoal)
        setAssetsWithGoal(assetsWithGoal);
      }
      setAssetsList(filteredAssets);
    }
    if (datares && datares.pagination) {
      setTotal(datares.pagination.total);
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };
  function updateAssetsWithGoalInfo(assets,goals,amortization) {
    return assets.map(asset => {
      const monetaryValue = calculateMonetoryValue(asset);
      if (asset.goal_id && asset.goal_id.length > 0) {
        // Filter the goals that match the asset's goal_id array
        const matchingGoals = goals && goals.filter(goal => asset.goal_id.includes(goal.id));
  
        // Sum the "Amount to use for this goal" from all matching goals

        // const sumOfAmountUsed = matchingGoals.reduce((sum, goal) => {
        //   const amount = goal["Amount to use for this goal"] ? goal["Amount to use for this goal"][0] : 0;
        //   return sum + amount;
        // }, 0);
        const sumOfAmountUsed = matchingGoals && matchingGoals.reduce((sum, goal) => {
          const amountArray = goal.assignAssets;
          const amount = amountArray && amountArray.length > 0 ? amountArray.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0) : 0;
          return sum + amount;
        }, 0);
        // calcution for amount in hand after subtraction values
        const assetName = asset["Name of Asset"];
        // const monetaryValue = calculateMonetoryValue(asset);
        console.log("monetaryValue",monetaryValue)
        const amortizationofRecord = amortization && amortization[assetName];
        const todaysDate = new Date();
        const GoalDate = data["Goal Date"]
          ? new Date(data["Goal Date"])
          : new Date();
          const loanPaybaleForAsset = amortizationofRecord
          ? amortizationofRecord
              .filter((record) => new Date(record.date) >= GoalDate)
              .reduce((total, record) => {
                const payable = record.valuepayable;
                return total + (typeof payable === "number" ? payable : 0);
              }, 0)
          : 0;
          const assetValueToday = monetaryValue
          ? +monetaryValue
          : 0;
          const taxabilityonAsset = asset["Taxes"] ? +asset["Taxes"] : 0;
          const costToSell = asset["Commission on Sale"]
          ? +asset["Commission on Sale"]
          : 0;
          const transactionCost = asset["Other Transaction Costs"]
          ? +asset["Other Transaction Costs"]
          : 0;
          const equityForGoal = (
            assetValueToday -
            taxabilityonAsset -
            costToSell -
            transactionCost -
            loanPaybaleForAsset
          ).toFixed(2);
        // Get the last goal in the matchingGoals array
        const amountAvailable = (equityForGoal ? equityForGoal : 0) - sumOfAmountUsed;

        // const lastGoal = matchingGoals && matchingGoals[matchingGoals.length - 1];

        const lastGoalId = asset.goal_id[asset.goal_id.length - 1];
         // Find the goal that matches the lastGoalId
        const lastGoal = goals.find(goal => goal.id === lastGoalId);
  
        // Extract relevant information from the last goal
        console.log("lastGoal",lastGoal,matchingGoals)
        const PreviousGoalsAssetUsedFor = lastGoal && lastGoal.assignAssets && lastGoal["Description of Goal"] ? lastGoal["Description of Goal"] : null;
        const PreviousGoalsAmount = lastGoal && lastGoal.assignAssets && lastGoal["Dollar Amount Needed"] && lastGoal["Dollar Amount Needed"] || null;
        const PreviuosGoalAmountUsed = lastGoal && lastGoal.assignAssets && lastGoal.assignAssets[0] && lastGoal.assignAssets[0].amountUseForGoal  ? lastGoal.assignAssets[0].amountUseForGoal : null;
  
        return {
          ...asset,
          "Monetary Value": +monetaryValue,
          sumOfAmountUsed,
          amountAvailable,
          PreviousGoalsAssetUsedFor,
          PreviousGoalsAmount,
          PreviuosGoalAmountUsed,
        };
      }
  
    // If no goal_id exists, still return the asset with calculated monetary value
    return {
      ...asset,
      "Monetary Value": +monetaryValue,
    };
    });
  }
  function calculateMonetoryValue(asset) {
    const currentDate =data["Goal Date"] ? new Date(data["Goal Date"]) : new Date();
    let Start = (asset["Cost Basis Date"] && new Date(asset["Cost Basis Date"])) || new Date();
    const differenceInMs = currentDate.getTime() - Start.getTime();
    const daysDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    let totalDays = daysDifference / 365;
  
    let Cost = +asset["Cost Basis"] || 0;
    let ReturnRate = +asset["Static"] || 0;
    let decimalValue = ReturnRate ? ReturnRate / 100 : 0;
    const amount = 1 + decimalValue / 365;
    let power = Math.pow(amount, totalDays * 365);
    const estimateDiff = Cost * power;
  
    if (estimateDiff > 0 && !isNaN(estimateDiff)) {
      return estimateDiff.toFixed(2);
    } else {
      return 0;
    }
  }
  
  // Example usage:
  // const updatedAssets = updateAssetsWithGoalInfo(records, Goals);


  // const transformedData = dataRes && transformData(dataRes);
  const transformedData = liabilities && calculatePayments(liabilities);
  const colsLiquidAssets = [
    {
      title: "Asset",
      dataIndex: "Name of Asset",
      sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
      render: (record) => (record ? record : "--------"),
    },
    {
      title: "Amount Available on Goal Date",
      // dataIndex:"amountAvailable",
      render: (fileName,record) =>
        record
          ? !isNaN(record.amountAvailable)
            ? `${"$" + (record.amountAvailable).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : record["Monetary Value"] && !isNaN(record["Monetary Value"]) && `${"$" + parseFloat(record["Monetary Value"]).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }`
          : "N/A",
      // render: (fileName, record) => {
      //   let result =
      //     record && calculateGoalRequirements(record, data, transformedData);
      //   return result && result.amountAvailable && result.amountAvailable ? (
      //     `${"$" + result.amountAvailable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      //   ) : (
      //     result.equityForGoal ? result.equityForGoal : "N/A"
      //   );
      // },
    },
    {
      title: "Previous Goals Asset Used For",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.goals && record.goals.length>0 ? (
          <div>
            <img
              style={{ cursor: "pointer", marginRight:"4px" }}
              src={matchImg}
              alt="matchImg"
              height={30}
              width={30}
              onClick={() => {
                const allGoalIds = record.goals.map(goal => goal.goalId);
                getSelectedRecords(allGoalIds,record.goals);
              }}
            ></img>
            <span>Yes</span>
          </div>
        ) : (
          <div>
            <span>None</span>
        </div>
        );
      },
    },
    {
      title: "Last Previous Goals Asset Used For",
      dataIndex: "PreviousGoalsAssetUsedFor",
      sorter: (a, b) => a["PreviousGoalsAssetUsedFor"] > b["PreviousGoalsAssetUsedFor"],
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Last Previous Goal Amount",
      dataIndex: "PreviousGoalsAmount",
      sorter: (a, b) => a["PreviousGoalsAmount"] - b["PreviousGoalsAmount"],
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Amount Used for Last Previous Goal",
      dataIndex: "PreviuosGoalAmountUsed",
      sorter: (a, b) => a["PreviuosGoalAmountUsed"] - b["PreviuosGoalAmountUsed"],
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Monthly Amount Needed to Save",
      sorter: (a, b) => a["PreviousGoalsAssetUsedFor"] > b["PreviousGoalsAssetUsedFor"],
      render: (fileName, record) => {
        let result = record && calculateGoalRequirements(record, data, transformedData);
        return result && result.monthlySavingRequired && result.monthlySavingRequired ? (
          `${"$" + (result.monthlySavingRequired).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        ) : (
          "N/A"
        );
      },
    },
    // {
    //   title: "Total Liabilities",
    //   // dataIndex: "Name of Asset",
    //   // sorter: (a, b) => a["Name of Asset"] > b["Name of Asset"],
    //   render: (fileName, record) => {
    //     let result =
    //       record && calculateGoalRequirements(record, data, transformedData);
    //     return result &&
    //       result.loanPayableForAsset &&
    //       result.loanPayableForAsset ? (
    //       <div>{result.loanPayableForAsset}</div>
    //     ) : (
    //       "N/A"
    //     );
    //   },
    // },

    {
      title: "SAVE TO THIS ASSET",
      render: (record, index) => {
        let isDisabled =
          dataSource && dataSource.some((item) => item.assetId === record.id);
        return (
          <React.Fragment>
            <button
              className="saveStatusbutton"
              // disabled={isDisabled ? true : false}
              style={{
                width: "100%",
                fontWeight: "bold",
                background: `${isDisabled ? "#E13C25" : ""}`,
                // cursor: `${isDisabled ? "not-allowed" : ""}`,
              }}
              onClick={async (e) => {
                e.preventDefault();
                if(isDisabled){
                  handleDelete(record);
                }
                else{
                  handleAdd(record);
                }
              }}
            >
              {isDisabled ? "Selected" : "Select"}
            </button>
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <div className="assetAssignTable" style={{ position: "relative" }}>
      <div className="goalSubFormTable">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h3 className="incomecardheading">Liquid Assets</h3>
        <ToolTipCreator name={"Goals_Liquid_Assets"}/>
      </div>
        <Table
          columns={colsLiquidAssets}
          dataSource={assetsWithGoal && assetsWithGoal}
          pagination={{
            total: totalPages * 10, // Assuming 10 items per page
            current: currentPage,
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
      </div>
      <Modal
      visible={detailsModal}
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      centered
    >
      <h3 className="modaltitle">Transaction Details</h3>

      <div>
        <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
          {selectedObject && selectedObject.length > 0 ? (
            <table id="clients">
              <thead>
                <tr>
                  <th>Goal Date</th>
                  <th>Description</th>
                  <th>Goal Need</th>
                  <th>Amount Assign</th>
                </tr>
              </thead>
              <tbody style={{}}>
                {selectedObject &&
                  selectedObject.map((data, index) => (
                    <tr key={index}>
                      <td>
                      {data["Goal Date"] ? moment(data["Goal Date"]).format("MM-DD-YYYY") : "N/A"}
                      </td>
                      <td>{data["Description of Goal"] ? data["Description of Goal"] : "N/A"}</td>
                      <td> ${" "}
                      {data["Dollar Amount Needed"]
                        ? `${data["Dollar Amount Needed"]
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                        : "0"}
                      
                      </td>
                      <td> ${" "}
                      {data.amountUseForGoal 
                        ? `${parseFloat(data.amountUseForGoal)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                        : "0"}
                      
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <h3 className="inputTitle">No Goal to Show</h3>
          )}
        </div>
      </div>

      <div className="buttonsMain" style={{ justifyContent: "center" }}>
        <button
          className="savebutton"
          onClick={() => {
            handleCancel();
          }}
        >
          Close
        </button>
      </div>
    </Modal>
      <NewLoader isLoading={loading} />
    </div>
  );
};
